/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import {useEffect, useState} from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import Moment from "moment";

// Images
import FormField from "../../components/FormFieldFormik";
import Autocomplete from "@mui/material/Autocomplete";
import MDButton from "../../../../../../components/MDButton";
import {useDispatch} from "react-redux";
import {notificationActions} from "../../../../../../store/notification/notification-slice";
import {useMeQuery} from "../../../../../../store/api/auth";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import Icon from "@mui/material/Icon";
import {useUserUpdateMutation} from "../../../../../../store/api/account";
import {format, parseISO} from "date-fns";
import {Form, Formik} from "formik";
import MDInput from "../../../../../../components/MDInput";
import {DatePicker} from "@mui/x-date-pickers";
import {TextField} from "@mui/material";
import form from "../../schemas/form";
import validations from "../../schemas/validations";

function UserInfo() {
    const {data: user} = useMeQuery();
    const [userUpdate] = useUserUpdateMutation()
    const [initialValues, setInitialValues] = useState(null);
    const [avatarUpload, setAvatarUpload] = useState(null);
    const {formId, formField} = form;
    const {first_name, last_name, gender, birth_day, email, phone, avatar} = formField;
    //   const {
    //   formField: { first_name, last_name, gender, birth_day, email, phone, avatar },
    // } = checkout;
    const [isEdit, setIsEdit] = useState(false);

    const dispatch = useDispatch();


    const backgroundColor = {
        style: {backgroundColor: 'rgb(255, 255, 255)'}
    }
    useEffect(() => {
        if (user) {
            setInitialValues({
                [first_name.name]: user.first_name ? user.first_name : "",
                [last_name.name]: user.last_name ? user.last_name : "",
                [email.name]: user.email ? user.email : "",
                [gender.name]: user.gender ? user.gender : "",
                // [birth_day.name]: user.birth_day ? user.birth_day : "",
                [phone.name]: user.phone ? user.phone : "",
                [avatar.name]: user.avatar,
            });
        }
    }, [user]);


    const handleAvatar = (e, setFieldValue) => {
        if (e.target.files.length === 0) {
            return;
        }
        const maxAllowedSize = 2 * 1024 * 1024;
        if (e.target.files[0].size > maxAllowedSize) {
            dispatch(notificationActions.showMessage({ message: "File is too big (max 2MB)", variant: "error" }));
        } else {
            setAvatarUpload(URL.createObjectURL(e.target.files[0]));
            setFieldValue("avatar", e.target.files[0]);
        }
    };

    const submitForm = async (values, actions) => {
        dispatch(notificationActions.showLoading(true));
        const save_user = new FormData();
        save_user.append("id", user.id);
        values.first_name !== user.first_name && save_user.append("first_name", values.first_name);
        values.last_name !== user.last_name && save_user.append("last_name", values.last_name);
        // values.birth_day !== user.birth_day && save_user.append("birth_day", format(values.birth_day, "yyyy-MM-dd"));
        values.gender !== user.gender && save_user.append("gender", values.gender);
        values.avatar.name && save_user.append("avatar", values.avatar);
        // values.phone && save_user.append("phone", values.phone);
        try {
            const payload = await userUpdate(save_user).unwrap();
            dispatch(notificationActions.showMessage({message: "updated successfully", variant: "success"}));
            actions.setSubmitting(false);
            actions.resetForm();
            setIsEdit(false);
        } catch (e) {
            for (const [key, value] of Object.entries(e.data)) {
                dispatch(notificationActions.showMessage({message: key + ": " + value, variant: "error"}));
            }
        }
        dispatch(notificationActions.showLoading(false));
    };

    const handleSubmit = (values, actions) => {
        submitForm(values, actions);
    };
    //
    //
    // const handleSave = async (e) => {
    //     setIsEdit(false);
    //     e.preventDefault();
    //     const save_user = new FormData();
    //     firstName && save_user.append("first_name", firstName);
    //     lastName && save_user.append("last_name", lastName);
    //     avatarUpload && save_user.append("avatar", avatarUpload);
    //     gender && save_user.append("gender", gender);
    //     birthDay && save_user.append("birth_day", birthDay);
    //
    //     dispatch(notificationActions.showLoading(true));
    //     try {
    //       const payload = await userUpdate(save_user);
    //       if(payload.error) {
    //         dispatch(notificationActions.showMessage({message: "An error occured", variant: 'error'}));
    //       } else {
    //         dispatch(notificationActions.showMessage({message: "Update successfully", variant: 'success'}));
    //       }
    //     }catch (e) {
    //       dispatch(notificationActions.showMessage({message: e.data.detail, variant: 'error'}));
    //     }
    //     dispatch(notificationActions.showLoading(false));
    // };
    const handleEditCancel = (e, setFieldValues) => {
      if (isEdit) {
          setFieldValues("first_name", user.first_name);
          setFieldValues("last_name", user.last_name);
          setFieldValues("avatar", user.avatar);
          setAvatarUpload(null);
          setFieldValues("birth_day", user.birth_day);
          setFieldValues("gender", user.gender);
      }
      setIsEdit(!isEdit);
    };
    const handleLogo = (e) => {
        if (e.target.files.length === 0) {
            return;
        }
        const maxAllowedSize = 2 * 1024 * 1024;
        if (e.target.files[0].size > maxAllowedSize) {
            dispatch(notificationActions.showMessage({message: "File is too big (max 2MB)", variant: "error"}));
        } else {
            setAvatarUpload(e.target.files[0]);
            const url = URL.createObjectURL(e.target.files[0]);
            setAvatar(url);
        }
    };
    const genderSelect = [
        {
            value: "M",
            label: "Male"
        },
        {
            value: "F",
            label: "Female"
        }];

    return (
        <>
            <Grid item xs={12}>
                <Card id="profile">
                    <MDBox p={2}>
                        {initialValues && <Formik
                            initialValues={initialValues}
                            validationSchema={validations}
                            enableReinitialize={true}
                            onSubmit={handleSubmit}
                        >
                            {({values, errors, touched, isSubmitting, setFieldValue, handleChange}) => {
                                const {
                                    first_name: firstNameV,
                                    last_name: lastNameV,
                                    gender: genderV,
                                    avatar: avatarV,
                                    // birth_day: birthDayV
                                } = values;

                                return (
                                    <Form id={formId} autoComplete="off">
                                        <MDBox my={3}>
                                            <MDBox mb={6}>
                                                <Grid container spacing={3} alignItems="center">
                                                    <Grid item xs={12} lg={9}>
                                                        <MDTypography variant="h4" fontWeight="medium">
                                                            User Info
                                                        </MDTypography>
                                                    </Grid>
                                                    <Grid item xs={12} lg={3}>
                                                        <MDBox display="flex" justifyContent="flex-end">
                                                            <MDButton disabled={isSubmitting}
                                                                      variant="gradient" color={isEdit ? "error" : "info"} onClick={(e)=>handleEditCancel(e,setFieldValue)}>
                                                                {!isEdit ? "Edit" : "Cancel"}
                                                            </MDButton>
                                                            <MDButton disabled={isSubmitting || !isEdit}
                                                                      type="submit" variant="gradient" color="success">
                                                                save
                                                            </MDButton>
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                        <input
                                                            accept="image/png, image/jpeg"
                                                            type="file"
                                                            id="user-avatar-file"
                                                            style={{display: "none"}}
                                                            disabled={!isEdit}
                                                            onChange={(e)=>handleAvatar(e,setFieldValue)}
                                                        />
                                                        <label htmlFor="user-avatar-file">
                                                            <IconButton color="primary" aria-label="upload picture"
                                                                        component="span">
                                                                <Badge badgeContent={<Icon>edit</Icon>} color="info"
                                                                       anchorOrigin={{
                                                                           vertical: "top",
                                                                           horizontal: "right"
                                                                       }}
                                                                       invisible={!isEdit}>
                                                                    <MDAvatar src={avatarUpload ? avatarUpload : avatarV}
                                                                              alt="Avatar"
                                                                              size="xl"
                                                                              shadow="sm"
                                                                    />
                                                                </Badge>
                                                            </IconButton>
                                                        </label>
                                                    </Grid>
                                                    <Grid item xs={12} sm={5}>
                                                        <MDBox mb={3}>
                                                            <MDBox mb={0} display="inline-block">
                                                                <MDTypography
                                                                    component="label"
                                                                    variant="button"
                                                                    fontWeight="regular"
                                                                    color="text"
                                                                    textTransform="capitalize"
                                                                >
                                                                    Name
                                                                </MDTypography>
                                                            </MDBox>
                                                            <FormField type={first_name.type}
                                                                       name={first_name.name}
                                                                       value={firstNameV}
                                                                       disabled={!isEdit}
                                                                       inputProps={backgroundColor}
                                                                       placeholder={first_name.placeholder}
                                                                       error={errors.first_name && touched.first_name}
                                                                       success={values.first_name.length > 0 && !errors.first_name}
                                                            />
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} sm={5}>
                                                        <MDBox mb={3}>
                                                            <MDBox mb={0} display="inline-block">
                                                                <MDTypography
                                                                    component="label"
                                                                    variant="button"
                                                                    fontWeight="regular"
                                                                    color="text"
                                                                    textTransform="capitalize"
                                                                >
                                                                    Last Name
                                                                </MDTypography>
                                                            </MDBox>
                                                            <FormField type={last_name.type}
                                                                       name={last_name.name}
                                                                       value={lastNameV}
                                                                       disabled={!isEdit}
                                                                       inputProps={backgroundColor}
                                                                       placeholder={last_name.placeholder}
                                                                       error={errors.last_name && touched.last_name}
                                                                       success={lastNameV.length > 0 && !errors.last_name}
                                                            />
                                                        </MDBox>
                                                    </Grid>
                                                    <Grid item xs={12} sm={2}>
                                                    </Grid>
                                                    <Grid item xs={12} sm={3}>
                                                        <MDBox mb={3}>
                                                            <MDBox mb={0} display="inline-block">
                                                                <MDTypography
                                                                    component="label"
                                                                    variant="button"
                                                                    fontWeight="regular"
                                                                    color="text"
                                                                    textTransform="capitalize"
                                                                >
                                                                    Gender
                                                                </MDTypography>
                                                            </MDBox>
                                                            <Autocomplete
                                                                value={genderSelect.find(e => e.value === genderV)}
                                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                                getOptionLabel={(g) => g.label}
                                                                options={genderSelect}
                                                                disabled={!isEdit}
                                                                disableClearable={true}
                                                                onChange={(e, newValue) => setFieldValue("gender", newValue.value)}
                                                                renderInput={(params) => <MDInput {...params}
                                                                                                  variant="standard"/>}
                                                            />
                                                        </MDBox>
                                                    </Grid>

                                                    {/*<Grid item xs={12} sm={6}>*/}
                                                    {/*    <DatePicker*/}
                                                    {/*        label="Birth Date"*/}
                                                    {/*        ampm={false}*/}
                                                    {/*        value={birthDayV}*/}
                                                    {/*        onChange={(newValue) => {*/}
                                                    {/*            setFieldValue("birth_day", newValue);*/}
                                                    {/*        }}*/}
                                                    {/*        disabled={!isEdit}*/}

                                                    {/*        renderInput={(params) => <TextField {...params} />}*/}
                                                    {/*    />*/}
                                                    {/*</Grid>*/}
                                                    <Grid item xs={12} sm={2}>
                                                    </Grid>
                                                    <Grid item xs={12} sm={5}>
                                                        <MDBox mb={3}>
                                                            <MDBox mb={0} display="inline-block">
                                                                <MDTypography
                                                                    component="label"
                                                                    variant="button"
                                                                    fontWeight="regular"
                                                                    color="text"
                                                                    textTransform="capitalize"
                                                                >
                                                                    Email
                                                                </MDTypography>
                                                            </MDBox>
                                                            <FormField type={email.type}
                                                                       name={email.name}
                                                                       value={values.email}
                                                                       placeholder={email.placeholder}
                                                                       disabled
                                                                       inputProps={backgroundColor}/>
                                                        </MDBox>
                                                    </Grid>
                                                    {/*<Grid item xs={12} sm={5}>*/}
                                                    {/*    <MDBox mb={3}>*/}
                                                    {/*        <MDBox mb={0} display="inline-block">*/}
                                                    {/*            <MDTypography*/}
                                                    {/*                component="label"*/}
                                                    {/*                variant="button"*/}
                                                    {/*                fontWeight="regular"*/}
                                                    {/*                color="text"*/}
                                                    {/*                textTransform="capitalize"*/}
                                                    {/*            >*/}
                                                    {/*                Phone Number*/}
                                                    {/*            </MDTypography>*/}
                                                    {/*        </MDBox>*/}
                                                    {/*        <FormField type={phone.type}*/}
                                                    {/*                   name={phone.name}*/}
                                                    {/*                   value={values.phone}*/}
                                                    {/*                   placeholder={phone.placeholder}*/}
                                                    {/*                   inputProps={backgroundColor}/>*/}
                                                    {/*    </MDBox>*/}
                                                    {/*</Grid>*/}
                                                </Grid>

                                            </MDBox>
                                            <Grid container spacing={3}>

                                            </Grid>
                                        </MDBox>
                                    </Form>
                                )
                            }}
                        </Formik>}
                    </MDBox>
                    {/*    <MDBox p={2}>*/}
                    {/*      <Grid container spacing={3} alignItems="center">*/}
                    {/*        <Grid item xs={12} sm={3}>*/}
                    {/*          <input*/}
                    {/*            accept="image/png, image/jpeg"*/}
                    {/*            type="file"*/}
                    {/*            id="user-avatar-file"*/}
                    {/*            style={{ display: "none" }}*/}
                    {/*            disabled={!isEdit}*/}
                    {/*            onChange={handleLogo}*/}
                    {/*          />*/}
                    {/*          <label htmlFor="user-avatar-file">*/}
                    {/*            <IconButton color="primary" aria-label="upload picture" component="span">*/}
                    {/*              <Badge badgeContent={<Icon>edit</Icon>} color="info"*/}
                    {/*                     anchorOrigin={{*/}
                    {/*                       vertical: "top",*/}
                    {/*                       horizontal: "right"*/}
                    {/*                     }}*/}
                    {/*                     invisible={!isEdit}>*/}
                    {/*                <MDAvatar src={avatar}*/}
                    {/*                          alt="Avatar"*/}
                    {/*                          size="xxl"*/}
                    {/*                          shadow="sm"*/}
                    {/*                          onChange={(e) => setAvatar(e.target.value)}*/}
                    {/*                />*/}
                    {/*              </Badge>*/}
                    {/*            </IconButton>*/}
                    {/*          </label>*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item  xs={12} sm={5}>*/}
                    {/*          <MDBox height="100%" mt={0.5} lineHeight={1}>*/}
                    {/*            <MDTypography variant="h5" fontWeight="medium">*/}
                    {/*              {user.first_name} {user.last_name}*/}
                    {/*            </MDTypography>*/}
                    {/*            <MDTypography variant="button" color="text" fontWeight="medium">*/}
                    {/*              Subscription End Date: {user.subscription ? parseISO(user.subscription[0].active_until).toLocaleString() : ""}*/}
                    {/*            </MDTypography>*/}
                    {/*          </MDBox>*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={4}>*/}
                    {/*          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }}>*/}

                    {/*          <MDBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>*/}
                    {/*          <MDButton variant="gradient" color={isEdit ? "error" : "info"} sx={{ height: "100%" }}*/}
                    {/*                      onClick={handleEditCancel}>*/}
                    {/*              {!isEdit ? "Edit" : "Cancel"}*/}
                    {/*            </MDButton>*/}
                    {/*          </MDBox>*/}
                    {/*          <MDBox ml={{ xs: 0, sm: 1 }} mt={{ xs: 1, sm: 0 }}>*/}
                    {/*          <MDButton variant="gradient" color="success"*/}
                    {/*                        sx={{ height: "100%" }}*/}
                    {/*                        ml={{ xs: 1, sm: 1 }}*/}
                    {/*                        disabled={!isEdit}*/}
                    {/*                        onClick={handleSave}*/}
                    {/*              >*/}
                    {/*                Save*/}
                    {/*              </MDButton>*/}
                    {/*          </MDBox>*/}
                    {/*          </MDBox>*/}
                    {/*        </Grid>*/}
                    {/*      </Grid>*/}
                    {/*    </MDBox>*/}
                    {/*  </Card>*/}
                    {/*</Grid>*/}
                    {/*<Grid item xs={12}>*/}
                    {/*  <Card id="basic-info" sx={{ overflow: "visible" }}>*/}
                    {/*    <MDBox p={3}>*/}
                    {/*      <MDTypography variant="h5">Info</MDTypography>*/}
                    {/*    </MDBox>*/}
                    {/*    <MDBox component="form" pb={3} px={3}>*/}
                    {/*      <Grid container spacing={3}>*/}
                    {/*        <Grid item xs={12} sm={6}>*/}
                    {/*          <FormField label="First Name" disabled={!isEdit}*/}
                    {/*                     value={firstName} onChange={(e) => setFirstName(e.target.value)} />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={6}>*/}
                    {/*          <FormField label="Last Name" disabled={!isEdit} value={lastName}*/}
                    {/*                     onChange={(e) => setLastName(e.target.value)} inputProps={backgroundColor} />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12}>*/}
                    {/*          <Grid container spacing={3}>*/}
                    {/*            <Grid item xs={12} sm={4}>*/}
                    {/*              <Autocomplete*/}
                    {/*                value={genderSelect.find(e=>e.value===gender)}*/}
                    {/*                isOptionEqualToValue={(option, value) => option.id === value.id}*/}
                    {/*                getOptionLabel={(g) => g.label}*/}
                    {/*                options={genderSelect}*/}
                    {/*                renderInput={(params) => (*/}
                    {/*                  <FormField {...params} label="I'm" disabled={!isEdit} InputLabelProps={{ shrink: true }}*/}
                    {/*                  />*/}
                    {/*                )}*/}
                    {/*                onChange={(e, newValue) => setGender(newValue.value)}*/}
                    {/*              />*/}
                    {/*            </Grid>*/}
                    {/*            <Grid item xs={12} sm={2}>*/}
                    {/*              <MDDatePicker input={{*/}
                    {/*                value: birthDay,*/}
                    {/*                disabled: !isEdit,*/}
                    {/*                label: "Birth Date"*/}
                    {/*              }}*/}
                    {/*                            onChange={([date]) => setBirthDay(Moment(date).format("YYYY-MM-DD"))}*/}
                    {/*              />*/}
                    {/*            </Grid>*/}
                    {/*          </Grid>*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} sm={6}>*/}
                    {/*          <FormField*/}
                    {/*            label="Email"*/}
                    {/*            value={email}*/}
                    {/*            inputProps={{ type: "email" }}*/}
                    {/*            onChange={(e) => setEmail(e.target.value)}*/}
                    {/*            disabled={true}*/}
                    {/*          />*/}
                    {/*        </Grid>*/}
                    {/*        /!*<Grid item xs={12} sm={6}>*!/*/}
                    {/*        /!*  <FormField*!/*/}
                    {/*        /!*    label="confirmation email"*!/*/}
                    {/*        /!*    value={confirmEmail}*!/*/}
                    {/*        /!*    inputProps={{ type: "email" }}*!/*/}
                    {/*        /!*    onChange={(e) => setConfirmEmail(e.target.value)}*!/*/}
                    {/*        /!*    disabled={!isEdit}*!/*/}
                    {/*        /!*  />*!/*/}
                    {/*        /!*</Grid>*!/*/}
                    {/*        <Grid item xs={12} sm={6}>*/}
                    {/*          <FormField*/}
                    {/*            label="Phone Number"*/}
                    {/*            value={phone}*/}
                    {/*            inputProps={{ type: "phone" }}*/}
                    {/*            onChange={(e) => setPhone(e.target.value)}*/}
                    {/*            disabled={true}*/}
                    {/*          />*/}
                    {/*        </Grid>*/}
                    {/*      </Grid>*/}
                    {/*    </MDBox>*/}
                </Card>
            </Grid>
        </>
    );

}

export default UserInfo;
